<template>
    <div>
        <Modal v-model="showModal" title="Add Project Member" no-footer footer-hide :before-close="handleReset">
            <div>
                <div class="savePTBtn">
                    <Button class="btn-color" :loading="isSaving" @click="handleConfirm"> Save </Button>
                </div>
                <Select v-model="addedUser" transfer clearable filterable @on-select="handleOnUserSelect">
                    <Option v-for="item in userList" :key="item.value" :value="item.value">
                        {{ item.label }}
                    </Option>
                </Select>

                <Table
                    :columns="tblColumns"
                    :data="tblData"
                    size="small"
                    :loading="isLoading"
                    height="300"
                    class="md-margin-top"
                >
                    <template slot="projectRole" slot-scope="{ row }">
                        <Select
                            v-model="row.projectRole"
                            transfer
                            clearable
                            filterable
                            @on-select="(data) => (tblData[row._index].projectRole = data.value)"
                        >
                            <Option
                                v-for="(role, idx) in projectMemberRoles.filter((x) => x != 'client')"
                                :key="idx"
                                :value="role"
                            >
                                {{ role }}
                            </Option>
                        </Select>
                    </template>
                </Table>
                <ErrorMessages v-if="errorMessages.length" ref="ErrorMessages" :errors="errorMessages" />
            </div>
        </Modal>
    </div>
</template>
<script>
import { getUsers } from '@/services/users.services';
import {
    getProjectMembersByProjectId,
    getProjectMembersRole,
    addBulkProjectMembers,
    deleteProjectMember,
} from '@/services/project-members.services';
import ErrorMessages from '@/components/UI/ErrorMessages';

export default {
    components: {
        ErrorMessages,
    },
    data() {
        return {
            errorMessages: [],
            isLoading: false,
            isSaving: false,
            showModal: false,
            userList: [],
            addedUser: null,
            projectMemberRoles: [],
            tblColumns: [
                {
                    title: 'Name',
                    key: 'name',
                    render: (h, params) => {
                        return h('span', params.row.user.name);
                    },
                },
                {
                    title: 'Project Role',
                    slot: 'projectRole',
                },
                {
                    title: 'Actions',
                    align: 'center',
                    width: 90,
                    render: (h, params) => {
                        return h('div', [
                            h(
                                'Icon',
                                {
                                    props: {
                                        type: 'md-close-circle',
                                        size: '20',
                                        color: '#ed4014',
                                    },
                                    on: {
                                        click: () => {
                                            this.handleRemoveUser(params.row._id);
                                        },
                                    },
                                },
                                'edit'
                            ),
                        ]);
                    },
                },
            ],
            tblData: [],
        };
    },
    methods: {
        handleGetUsers() {
            this.isLoading = true;
            this.userList = [];
            getUsers()
                .then((res) => {
                    if (res.data.length) {
                        let resData = res.data.filter((x) => x.mainRole != 'client' && x.isArchived == false);

                        const exisitingUsers = this.tblData.map((x) => x.user._id);
                        const result = resData.filter((x) => exisitingUsers.indexOf(x._id) == -1);
                        this.userList = result.map((i) => {
                            return {
                                value: i._id,
                                label: i.name,
                                name: i.name,
                                id: i._id,
                                _id: i._id,
                            };
                        });
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get users');
                    this.isLoading = false;
                });
        },

        async handleGetProjectMembers() {
            this.isLoading = true;
            this.tblData = [];
            return await getProjectMembersByProjectId(this.$route.query.id)
                .then((res) => {
                    if (res.data.length) {
                        const resData = res.data.filter((x) => {
                            if (x.projectRole !== 'client' && x.user.isArchived !== true) {
                                return {
                                    project: x.project._id,
                                    projectRole: x.projectRole,
                                    user: x.user,
                                };
                            }
                        });
                        this.isLoading = false;
                        return resData;
                    } else {
                        this.isLoading = false;
                        return [];
                    }
                })
                .catch(() => {
                    this.$Message.error('Failed to get project members');
                    this.isLoading = false;
                    return [];
                });
        },

        handleGetProjectMemberRoles() {
            getProjectMembersRole().then((res) => {
                this.projectMemberRoles = [];
                if (res.data.length) {
                    this.projectMemberRoles = res.data;
                }
            });
        },
        async openModal() {
            this.tblData = await this.handleGetProjectMembers();
            await this.handleGetUsers();
            this.handleGetProjectMemberRoles();
            this.showModal = true;
        },

        handleConfirm() {
            const data = this.tblData.map((x) => {
                if (!x.projectRole) {
                    return {
                        name: x.user.name,
                        hasEmptyField: true,
                    };
                } else {
                    return {
                        name: x.user.name,
                        hasEmptyField: false,
                    };
                }
            });
            if (data.filter((data) => data.hasEmptyField === true).length > 0) {
                this.errorMessages.push('Project Role cannot be empty');
            } else {
                this.handleAddProjectMember();
            }
        },

        async handleAddProjectMember() {
            this.isSaving = true;
            const data = this.tblData.map((x) => {
                return {
                    project: this.$route.query.id,
                    projectRole: x.projectRole,
                    user: x.user._id,
                };
            });
            addBulkProjectMembers(data)
                .then(() => {
                    this.$emit('addPT');
                    this.isSaving = false;
                    this.errorMessages = [];
                    this.showModal = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to add project members');
                    this.isSaving = false;
                });
        },

        handleOnUserSelect(val) {
            const users = [...this.userList];
            this.userList = [];
            const selectedUser = users.find((u) => u.id === val.value);
            this.userList = users.filter((u) => u.id !== val.value);
            this.tblData.push({ user: selectedUser, projectRole: '' });
            this.addedUser = null;
        },

        handleRemoveUser(id) {
            this.tblData = this.tblData.filter((x) => x._id !== id);
            deleteProjectMember(id)
                .then(() => {
                    this.$emit('addPT');
                    this.$Message.success('Project member removed successfully');
                })
                .catch(() => {
                    this.$Message.error('Failed to remove a project member');
                });
        },
        handleReset() {
            this.errorMessages = [];
            this.isLoading = false;
            this.showModal = false;
        },
    },
};
</script>
<style scoped>
.savePTBtn {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
}
</style>
